const fromdata = [
	{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		width: "210px",
		lablewith: "100px",
		btx: true,
		options: []
	},
	{
		inputdata: "",
		title: "年度指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: true
	},
	{
		inputdata: "",
		title: "1月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "2月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "3月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "4月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "5月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "6月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "7月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "8月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "9月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "10月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "11月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	},
	{
		inputdata: "",
		title: "12月指标",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "number",
		inputtype: "input",
		width: "210px",
		lablewith: "100px",
		btx: false
	}
];
export default fromdata;
